import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { ChatCapabilities } from '../components/ChatStart/ChatCapabilities';
import { StarterPrompts } from '../components/ChatStart/StarterPrompts';
import { PromptComposer } from '../components/PromptComposer';
import { useStarterPrompts } from '../lib/chat/starters';
// Landing state for the /assistant surface: the composer to start a new chat.
// The explore rail + breadcrumb handling live in AssistantLayout.
export default function Assistant() {
    const starters = useStarterPrompts();
    // A new object per pick, so picking the same starter twice still refills.
    const [draft, setDraft] = useState();
    const fill = (text)=>setDraft({
            text
        });
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col h-full bg-background",
        children: /*#__PURE__*/ _jsx(AnimatePresence, {
            mode: "wait",
            children: /*#__PURE__*/ _jsx(motion.div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                exit: {
                    opacity: 0
                },
                transition: {
                    duration: 0.3
                },
                className: "flex flex-col flex-1",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex-1 overflow-y-auto flex items-center justify-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "w-full max-w-[860px] px-8 py-8",
                        children: [
                            /*#__PURE__*/ _jsx(PromptComposer, {
                                mode: "chat",
                                draft: draft
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mt-4 space-y-3",
                                children: [
                                    /*#__PURE__*/ _jsx(StarterPrompts, {
                                        starters: starters,
                                        onPick: fill
                                    }),
                                    /*#__PURE__*/ _jsx(ChatCapabilities, {
                                        onTry: fill
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, "composer")
        })
    });
}
